import { render, staticRenderFns } from "./ripple.vue?vue&type=template&id=341460a5&scoped=true&"
import script from "./ripple.vue?vue&type=script&lang=ts&"
export * from "./ripple.vue?vue&type=script&lang=ts&"
import style0 from "./ripple.vue?vue&type=style&index=0&id=341460a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341460a5",
  null
  
)

component.options.__file = "ripple.vue"
export default component.exports